import React from "react";
import { authenticatedUser, isAuthenticating } from "../../redux/slice";
import { useSelector } from "react-redux";

const withAuthorization = (allowedRoles) => (WrappedComponent) => (props) => {
    const user = useSelector(authenticatedUser);
    const authenticating = useSelector(isAuthenticating);

    if (authenticating) {
        return null;
    }

    if (!user || !user.role) {
        return null;
    }

    return allowedRoles.includes(user.role) ? <WrappedComponent {...props} /> : null;
};

export const Admin = withAuthorization(["admin"]);
export const Supervisor = withAuthorization(["admin", "supervisor"]);
export const Manager = withAuthorization(["admin", "supervisor", "manager"]);
export const Assistant = withAuthorization(["assistant"]);

export default withAuthorization;
